import { CompAudioCore } from '../core/audio/comp'

export const CompAudio = CompAudioCore
